<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <b-container fluid>
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Garantias</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>Admin_Tx_Garant</div>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="subtitulos">Administración de tratamientos a garantias</b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-row align-v="center">
            <b-col class="col-6">
              <b-form v-on:submit.prevent="buscarPaciente">
                <b-form-group align="left">
                  <b-input-group prepend="ID del paciente" class="mt-3">
                    <b-form-input v-model="busqueda"></b-form-input>
                    <b-input-group-append>
                      <b-button variant="outline-primary" :disabled="loader" type="submit">
                        <b-icon v-if="!loader" icon="search"></b-icon>
                        <b-spinner v-else variant="primary" small label="Small Spinning"></b-spinner>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-form>
            </b-col>
          </b-row>
          <div v-if="datosPaciente != null && datosPaciente != undefined">
            <hr>
            <h5 class="titulo">Información del paciente</h5>
            <b-row>
              <b-col>
                <p><label>Clave: </label> <span> {{ datosPaciente.idPaciente }}</span></p>
              </b-col>
              <b-col>
                <p><label>Nombre: </label> <span> {{ datosPaciente.nombre }}</span></p>
              </b-col>
              <b-col>
                <p><label>Fecha de nacimiento: </label> <span> {{ datosPaciente.fecha|formatoFecha }}</span></p>
              </b-col>
            </b-row>
          </div>
          <div v-if="datosPaciente != null && datosPaciente != undefined">
            <hr>
            <h5 class="titulo">Tratamientos Realizados</h5>
            <b-row>
              <b-table
                  id="Pacientes"
                  thead-tr-class="columnas"
                  :items="tratamientos"
                  :fields="fields"
                  responsive="true"
                  class="parrafos"
                  show-empty
                  fixed
              >
                <template v-slot:cell(fecha)="row">
                  {{ row.item.fecha | formatoFecha }}
                </template>
                <template v-slot:cell(Op)="row">
                  <b-form-checkbox v-model="row.item.seleccionado"
                                   v-on:change="selecionarTratamiento(row.item)"></b-form-checkbox>
                </template>
              </b-table>
            </b-row>
          </div>
          <div v-if="garantias.length>0">
            <hr>
            <h5 class="titulo">Garantias</h5>
            <b-row>
              <b-col>
                <b-form-group align="left">
                  <label for="clinica">Clínica a resolver</label>
                  <v-select
                      name="clinica"
                      label="strNombre"
                      v-model="datos.idClinica"
                      :reduce="(variable) => variable.idClinica"
                      :options="clinicas"
                      @input="buscarDoctores()"
                  ></v-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-table
                  id="Pacientes"
                  thead-tr-class="columnas"
                  :items="garantias"
                  :fields="fieldsGarantias"
                  responsive="true"
                  class="parrafos"
                  show-empty
                  fixed
              >
                <template v-slot:cell(fecha)="row">
                  {{ row.item.fecha | formatoFecha }}
                </template>
                <template v-slot:cell(tratamiento)="row">
                  <v-select
                      :disabled="guardados.length >0 "
                      v-model="row.item.idTratamiento"
                      :options="catTratamientos.filter(value => {
                              return row.item.idEmpleado ==null ||
                              listaDoctores.find(d => d.idEmpleado === row.item.idEmpleado).tratamientos.includes(value.idTratamiento)
                            })"
                      :reduce="(variable) => variable.idTratamiento"
                      label="nombre"
                      @input="row.item.idTratamiento == null ? row.item.idEmpleado = null : null"
                  >
                  </v-select>
                </template>
                <template v-slot:cell(nuevo)="row">
                  <b-spinner v-if="cargando" variant="primary" small label="Small Spinning"></b-spinner>
                  <v-select v-if="datos.idClinica != null & !cargando"
                            :disabled="guardados.length >0 "
                            v-model="row.item.idEmpleado"
                            :options="listaDoctores.filter(value => {return row.item.idTratamiento == null|| value.tratamientos.includes(row.item.idTratamiento)})"
                            :reduce="(variable) => variable.idEmpleado"
                            label="nombreDoctor"
                  >
                  </v-select>
                </template>
                <template v-slot:cell(Acciones)="row">
                  <b-button variant="danger" size="sm"
                            @click="eliminarTratamiento(row.item.idTratamientoProgramado,row.index)">
                    <b-icon icon="trash"></b-icon>
                  </b-button>
                </template>
              </b-table>
            </b-row>
            <b-row>
              <b-col>
                <b-button variant="outline-primary"
                          :disabled="datos.idClinica == null || loaderAcciones || guardados.length > 0"
                          @click="asignar()">
                  <span v-if="!loaderAcciones">Asignar</span>
                  <span v-else>Asignando</span>
                </b-button>
              </b-col>
            </b-row>
          </div>
          <div v-if="guardados.length > 0 ">
            <hr>
            <h5 class="titulo">Tratamientos Guardados</h5>
            <b-row>
              <b-table
                  id="Pacientes"
                  thead-tr-class="columnas"
                  :items="guardados"
                  :fields="fieldGuardados"
                  responsive="true"
                  class="parrafos"
                  show-empty
                  fixed
              >
              </b-table>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Header from "@/components/Header";

export default {
  name: "Garantias",
  components: {Header},
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      loader: false,
      loaderAcciones: false,
      cargando: false,
      busqueda: null,
      datos: {
        idClinica: null,
        idEmpleado: null,
        tratamientos: []
      },
      listaDoctores: [],
      datosPaciente: null,
      tratamientos: [],
      catTratamientos: [],
      txValidos: [],
      garantias: [],
      clinicas: [],
      doctores: [],
      guardados: [],
      fields: [
        "Op",
        {key: "fecha", label: "Fecha", sortable: true},
        {key: "clinica", label: "Clínica", sortable: true},
        {key: "doctor", label: "Doctor", sortable: true},
        {key: "tratamiento", label: "Tratamiento", sortable: true},
        {key: "sup", label: "Sup", sortable: true},
        {key: "od", label: "OD", sortable: true},
        {key: "sesion", label: "Sesión", sortable: true},
        {key: "ultimo", label: "Última?", sortable: true},
        {key: "cantidad", label: "Cantidad", sortable: true},
        {key: "recibo", label: "Recibo", sortable: true},

      ],
      fieldsGarantias: [
        {key: "fecha", label: "Fecha", sortable: true},
        {key: "clinica", label: "Clínica", sortable: true},
        {key: "doctor", label: "Doctor", sortable: true},
        {key: "tratamiento", label: "Tratamiento", sortable: true, thClass: 'DoctorTable'},
        {key: "od", label: "OD", sortable: true, thClass: 'anchoTable'},
        {key: "sesion", label: "Sesión", sortable: true, thClass: 'sesionTable'},
        {key: "nuevo", label: "Doctor a realizar", sortable: true, thClass: 'DoctorTable'},
      ],
      fieldGuardados: [
        {key: "clinica", label: "Clínica", sortable: true},
        {key: "doctor", label: "Doctor", sortable: true},
        {key: "tratamiento", label: "Tratamiento", sortable: true, thClass: 'DoctorTable'},
        {key: "od", label: "OD", sortable: true, thClass: 'anchoTable'},
        {key: "sesion", label: "Sesión", sortable: true, thClass: 'sesionTable'},
        {key: "ultimo", label: "Última?", sortable: true},
      ],
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.getClinicas();
    this.obtenerTratamientos();
  },
  methods: {
    getClinicas() {
      this.$http
          .get(this.$api + "catalogos/listaClinicas")
          .then((response) => {
            if (response.status === 200) {
              this.clinicas = response.data.data
            }
          })
          .catch((error) => {
            console.error(error);
          });
    },
    obtenerTratamientos() {
      this.$http.get(this.$api + 'planConvenio/obtener/tratamientos/categoria').then(
          respuesta => {
            if (respuesta.data.data) {
              this.catTratamientos = respuesta.data.data;
            }

          }
      )
    },
    buscarPaciente() {
      this.guardados = [];
      this.garantias = [];
      this.tratamientos = [];
      this.datosPaciente = null
      this.datos.idClinica = null
      this.loader = true;
      const parametros = {idPaciente: this.busqueda}
      this.$http
          .post(this.$api + "garantias/obtenerDatosPaciente", parametros)
          .then((response) => {
            if (response.status === 200) {
              if (response.data.data != null) {
                this.datosPaciente = response.data.data
                this.tratamientos = response.data.data.tratamientos

                this.tratamientos.map(value => {
                  value.seleccionado = false
                })
              } else {
                const Toast = this.$swal.mixin({
                  toast: true,
                  position: 'top-end',
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true,
                  didOpen: (toast) => {
                    toast.addEventListener('mouseenter', this.$swal.stopTimer)
                    toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                  }
                })

                Toast.fire({
                  icon: 'warning',
                  title: 'No se encontró informacion del id proporcionado'
                })
              }
            }
          })
          .catch((error) => {
            console.error(error);
            this.$swal.fire({
              icon: "error",
              text: 'Ocurrio un error al generar la busqueda',
            });
          }).finally(() => {
        this.loader = false;
      });
    },
    selecionarTratamiento(item) {
      item.seleccionado = !item.seleccionado;
      if (item.seleccionado) {
        this.garantias.push(item);
      } else {
        this.garantias = this.garantias.filter(value => value.idTratamientoProgramado !== item.idTratamientoProgramado);
      }
    },
    eliminarTratamiento(item, index) {

      const lista = JSON.parse(JSON.stringify(this.tratamientos))
      lista.map(value => {
        if (value.idTratamientoProgramado === item) {
          value.seleccionado = false;
          this.garantias.splice(index, 1);
        }
      })
      this.tratamientos = lista
    },
    asignar() {
      this.loaderAcciones = true

      this.$http
          .post(this.$api + "garantias/guardarGarantia?idClinica=" + this.datos.idClinica + "&idPaciente=" + this.datosPaciente.idPaciente, this.garantias)
          .then((response) => {
            if (response.status === 200) {
              this.guardados = response.data.data;
              this.$swal.fire({
                icon: "success",
                text: 'La garantia se generó correctamente',
              });

            } else {
              this.$swal.fire({
                icon: "error",
                text: 'Ocurrio un error al guardar los datos',
              });
            }
          })
          .catch((error) => {
            console.error(error);

          }).finally(() => {
        this.loaderAcciones = false;
      });
    },
    buscarDoctores() {
      this.cargando = true;
      this.garantias.map(value => {
        value.idEmpleado = null
      })
      const url =
          this.$api +
          "colaboradores/obtener/nombres";
      this.$http
          .post(url, this.datos.idClinica)
          .then((response) => {
            this.listaDoctores = response.data.data;
          })
          .finally(() => {
            this.cargando = false;
          });
    },
  },

}
</script>

<style scoped>

</style>